import logger from 'shared/services/logger'
import MoreProductsContainer from 'views/containers/browser/MoreProductsContainer'
import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

export default ({ container, i18n }) => {
  logger.info('MoreProducts module loaded')

  const {
    dataset: { items },
  } = container

  try {
    const products = JSON.parse(items)
    const noSlider = container.closest('.o-SliderHorizontal__wrapper--noSlider')

    hydrateWithHOCs({
      container,
      i18n,
    })(<MoreProductsContainer products={products} noSlider={noSlider} />)
  } catch (error) {
    logger.error(error.message)
  }
}
